module.exports = __webpack_public_path__ + "img/homeWhite.edc5b0d7.svg";